module.exports = __webpack_public_path__ + "static/media/octes8h_0.f25e8ba0.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/octes/octes8h_0.svg
// module id = 745
// module chunks = 0